import { render, staticRenderFns } from "./XSwitch.vue?vue&type=template&id=9c6ec68c"
import script from "./XSwitch.vue?vue&type=script&lang=js"
export * from "./XSwitch.vue?vue&type=script&lang=js"
import style0 from "./XSwitch.vue?vue&type=style&index=0&id=9c6ec68c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports